import React from 'react'
import { Paper, Typography, Icon } from '@design/pt-ui'

import { translateWithUserLocale } from '../../utils/i18n'

const Component = () => {
  return (
    <>
      <Paper sx={{ p: '10px' }}>
        <span
          style={{ display: 'flex', marginBottom: 10, alignItems: 'center' }}>
          <Icon
            sx={{
              fontSize: 150,
              color: 'warning.light',
              marginRight: '10px',
            }}>
            warning
          </Icon>
          <Typography variant="body2">
            {translateWithUserLocale('disclaimer')}
          </Typography>
        </span>
        <span>{translateWithUserLocale('disclaimer.creative_details')}</span>
      </Paper>
    </>
  )
}

export default Component
